"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PrequalSliderSelectionSource = exports.DebtSwapTradelineSelectionBlockReason = exports.PrequalSliderPresentationType = void 0;
var PrequalSliderPresentationType;
(function (PrequalSliderPresentationType) {
    PrequalSliderPresentationType["V1"] = "V1";
    PrequalSliderPresentationType["V2"] = "V2";
    PrequalSliderPresentationType["NONE"] = "NONE";
})(PrequalSliderPresentationType || (exports.PrequalSliderPresentationType = PrequalSliderPresentationType = {}));
var DebtSwapTradelineSelectionBlockReason;
(function (DebtSwapTradelineSelectionBlockReason) {
    DebtSwapTradelineSelectionBlockReason["requiredForDtiRecovery"] = "requiredForDtiRecovery";
})(DebtSwapTradelineSelectionBlockReason || (exports.DebtSwapTradelineSelectionBlockReason = DebtSwapTradelineSelectionBlockReason = {}));
var PrequalSliderSelectionSource;
(function (PrequalSliderSelectionSource) {
    PrequalSliderSelectionSource["MortgageLoanOfficer"] = "MortgageLoanOfficer";
    PrequalSliderSelectionSource["Applicant"] = "Applicant";
})(PrequalSliderSelectionSource || (exports.PrequalSliderSelectionSource = PrequalSliderSelectionSource = {}));
